<template>
  <b-modal
    ref="teacher-notification-inbox-detail"
    id="teacher-notification-inbox-detail"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    @shown="markAsRead"
  >
    <b-row v-if="notification">
      <b-col md="12">
        <h4 class="purple mb-4">Detalhes da notificação</h4>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="Data">
          <b-form-input
            type="text"
            :value="formatDate(notification.created_at)"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="De">
          <b-form-input
            type="text"
            :value="notification.Creator ? notification.Creator.name : ''"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="Ciclo">
          <b-form-input
            type="text"
            :value="notification.Cycle ? notification.Cycle.name : ''"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" class="mt-2">
        <b-form-group label="Aluno">
          <b-form-input
            type="text"
            :value="notification.Student ? notification.Student.User.name : ''"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12" class="mt-2">
        <b-form-group label="Área do Conhecimento">
          <b-form-input
            type="text"
            :value="notification.Subject ? notification.Subject.designation : ''"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12" class="mt-2">
        <b-form-group label="Mensagem">
          <b-form-textarea
            :value="notification.message"
            rows="4"
            disabled
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-5" v-if="notification">
      <b-col class="text-right">
        <button
          type="button"
          class="btn large resolve-btn mr-2"
          :disabled="notification.resolved_at > 0"
          @click="confirmResolve"
        >
          {{ notification.resolved_at > 0 ? "Resolvido" : "Resolver" }}
        </button>
        <b-button class="btn large blue" @click="close">Fechar</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import moment from "moment-timezone";
import { mapActions } from "vuex";
import TeacherNotificationInboxService from "@/services/teacherNotificationInbox.service";

export default {
  name: "",

  props: {
    notification: {
      type: Object,
      default: null,
    },
  },

  methods: {
    ...mapActions({
      refreshTeacherPendingNotifications:
        "shared/refreshTeacherPendingNotifications",
    }),

    close() {
      this.$refs["teacher-notification-inbox-detail"].hide();
    },

    confirmResolve() {
      const student =
        this.notification.Student && this.notification.Student.User
          ? this.notification.Student.User.name
          : "";
      const messageText = student
        ? `Marcar a pendência de ${student} como resolvida?`
        : "Marcar a pendência como resolvida?";
      this.$swal
        .fire({
          title: "Resolver pendência?",
          text: messageText,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, resolver!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.markResolved();
          }
        });
    },

    async markResolved() {
      if (this.notification.resolved_at > 0) {
        return;
      }

      try {
        const response = await TeacherNotificationInboxService.markResolved(
          this.notification.id
        );
        this.notification.resolved_at = response.data.resolved_at;
        this.refreshTeacherPendingNotifications();
      } catch (error) {
        return
      }
    },
    async markAsRead() {
      if (!this.notification || this.notification.readed_at > 0) {
        return;
      }

      try {
        const response = await TeacherNotificationInboxService.markRead(
          this.notification.id
        );
        this.notification.readed_at = response.data.readed_at;
        this.refreshTeacherPendingNotifications();
      } catch (error) {
        return
      }
    },

    formatDate(date) {
      return moment.tz(date, "America/Sao_Paulo").format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";

div#teacher-notification-inbox-detail {
  .modal-dialog {
    max-width: 820px;
    .modal-content {
      background-color: $grey2;
      border: 0;
      border-radius: 0;
      .modal-body {
        padding: 60px;
      }
    }
  }

  .resolve-btn {
    background-color: $orange;
    border-color: $orange;
    color: $white;

    &:hover:not(:disabled) {
      background-color: transparent;
      border-color: $orange;
      color: $grey4;
    }

    &:focus,
    &:active {
      border-color: $orange !important;
      color: $grey4 !important;
    }

    &:disabled {
      background-color: $purple;
      border-color: $purple;
      color: $white;
      opacity: 1;
    }
  }
}
</style>
